export const MAP_CONFIG = {
  id: 'dynamicps/cjfykahxxdwth2srvgu4dfxjj',
  style: `https://api.mapbox.com/styles/v1/{id}/tiles/256/{z}/{x}/{y}@2x?access_token={accessToken}`,
  center: [-121.942577, 38.3],
  zoom: 10.2,
  maxZoom: 23,
  scrollZoom: true,
  dragRotate: false,
  touchZoomRotate: false
}